import {NgModule}                from '@angular/core';
import {RouterModule, Routes}    from '@angular/router';
import { SettingsComponent } from './components/settings.component';
import { OrganisationResolver } from './resolvers/organisation.resolver';

const routes: Routes = [
    {
        path: ':id',
        component: SettingsComponent,
        resolve: {
            organisation: OrganisationResolver
        },
        data: {
            permission: 'view_settings'
        },
    }
];

@NgModule({
    providers: [],
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SettingsRoutingModule
{
}
